//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
`;
export const ContainerTimeBlock = styled.section`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    padding: 10px;
    width: 170px;
    &:not(:last-child) {
        border-right: 2px solid var(--light-blue-2);
    }
    & h4 {
        margin-bottom: 20px;
    }
`;